import React, { useState } from 'react';
import MediaCard from '../components/MediaCard';
import Lightbox from '../components/Lightbox';
import { useMedia } from '../hooks/useMedia';
import { iconFor } from '../lib/icons';

export default function Animation({ category, input, fallback }) {
  const [selected, setSelected] = useState(null);
  const { items: remote } = useMedia(category.key);
  const works = remote === null ? [] : remote.length ? remote : (fallback || []);

  return (
    <div className="page-in w-full max-w-[1800px] mx-auto px-4 md:px-6 py-4 md:py-6 lg:py-8" data-testid={`page-${category.key}`}>
      <PageHeader input={input} title={category.name} icon={iconFor(category.icon)} />
      {remote && !works.length && <EmptyChannel />}
      <div className="grid gap-4 md:gap-5" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 380px), 460px))', justifyContent: 'center' }}>
        {works.map((item, i) => (
          <MediaCard key={item.id} item={item} kind={item.type || 'video'} onOpen={setSelected} index={i} />
        ))}
      </div>
      <Lightbox item={selected} kind={selected?.type || 'video'} onClose={() => setSelected(null)} />
    </div>
  );
}

export function PageHeader({ input, title, icon: Icon }) {
  return (
    <div className="mb-5 md:mb-7 flex items-end justify-between gap-6 flex-wrap border-b border-[#3a2512] pb-3 md:pb-4">
      <div>
        <div className="font-osd text-[#f5a623] tracking-widest text-xs md:text-sm mb-0.5">// INPUT {input} · SOURCE SELECTED</div>
        <h1 className="font-display text-3xl md:text-4xl lg:text-5xl text-[#ffe9b8] phosphor-glow leading-none" data-testid="page-title">{title}</h1>
      </div>
      {Icon && (
        <Icon className="w-9 h-9 md:w-11 md:h-11 text-[#f5a623]" />
      )}
    </div>
  );
}

export function EmptyChannel() {
  return (
    <div className="border-2 border-dashed border-[#5a3418] rounded-lg px-5 py-12 text-center font-osd text-sm tracking-widest text-[#8b6a3e] bg-[#1a0e05]/40" data-testid="empty-channel">
      // STAND BY — NO BROADCASTS ON THIS CHANNEL YET
    </div>
  );
}
